<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard" *ngIf="!contentLoading">
    <div class="head">
      <h1>{{ coloringImageId ? "Edit Coloring Image" : "Add New Coloring Image" }}</h1>
    </div>
    <form id="translation" [formGroup]="mainForm">
      <!-- Alternative: Using existing grid/column classes if available -->
      <div class="challengeFormWrapper">
        <div class="grid-wrapper" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
          <!-- Main Image Upload -->
          <div>
            <label class="image-wrapper-label block-pointer">
              <span class="upload-label">Upload Image</span>
              <div class="borderedWrapper">
                <div class="fileSection">
                  <label for="imageFile" class="unblock-pointer">
                    Choose A File
                    <input type="file" id="imageFile" #imagefileInput (change)="onImageUpload($event)" accept=".svg"
                      formControlName="imageUrl" />
                  </label>
                  <div class="uploadedFiles" *ngIf="imageFileName">
                    <ul>
                      <li>
                        <h6>{{ imageFileName }}</h6>
                        <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" class="unblock-pointer"
                          style="cursor: pointer" (click)="clearImageUpload()" />
                      </li>
                    </ul>
                  </div>
                </div>
                <h6>
                  Image should be in SVG format and not exceed 15MB.
                </h6>
              </div>
            </label>
          </div>

          <!-- Thumb Image Upload -->
          <div>
            <label class="image-wrapper-label block-pointer">
              <span class="upload-label">Upload Thumb Image</span>
              <div class="borderedWrapper">
                <div class="fileSection">
                  <label for="thumbFile" class="unblock-pointer">
                    Choose A File
                    <input type="file" id="thumbFile" #thumbFileInput (change)="onThumbImageUpload($event)"
                      accept=".jpg,.jpeg,.png,.pdf" formControlName="thumbURL" />
                  </label>
                  <div class="uploadedFiles" *ngIf="thumbFileName">
                    <ul>
                      <li>
                        <h6>{{ thumbFileName }}</h6>
                        <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" class="unblock-pointer"
                          style="cursor: pointer" (click)="clearThumbUpload()" />
                      </li>
                    </ul>
                  </div>
                </div>
                <h6>
                  Thumb should be in PNG/JPG/PDF format and not exceed 15MB.
                </h6>
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- CREATE MODE: Show form to add translations -->
      <div *ngIf="!coloringImageId" class="challengeLangWrapper">
        <div class="challengeFormWrapper">
          <label class="width-Wrapper">
            <span>Choose Language</span>
            <mat-form-field appearance="fill">
              <mat-select formControlName="langId" placeholder="Language" (selectionChange)="onLanguageSelect($event)">
                <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                  {{ lang.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </label>

          <label class="full-width-wrapper block-pointer">
            <span>Title</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Title" formControlName="title" maxlength="51" />

              <mat-error *ngIf="mainForm.get('title')?.hasError('minlength')">
                Title must be at least 2 characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('required')">
                Title is required
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('maxlength')">
                Title cannot exceed 50 characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('onlyNumbers')">
                Title cannot contain only numbers
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('onlySpecialChars')">
                Title cannot contain only special characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('noAlphabet')">
                Title must contain at least one alphabet character
              </mat-error>
            </mat-form-field>
          </label>
        </div>

        <div class="btn-wrapper-div" *ngIf="coloringImageTranslations?.length !== languages.length">
          <p>Add at least one translation to save</p>
          <button type="button" (click)="addColoringImageTable()" class="add-button">
            Add
          </button>
        </div>
      </div>

      <!-- EDIT MODE: Show form to add MORE translations (if needed) -->
      <div *ngIf="coloringImageId" class="challengeLangWrapper">
        <div class="challengeFormWrapper">
          <label class="width-Wrapper">
            <span>Choose Language</span>
            <mat-form-field appearance="fill">
              <mat-select formControlName="langId" placeholder="Language" (selectionChange)="onLanguageSelect($event)">
                <mat-option *ngFor="let lang of languages" [disabled]="isLangUsed(lang.id)" [value]="lang.id">
                  {{ lang.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </label>

          <label class="full-width-wrapper block-pointer">
            <span>Title</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Title" formControlName="title" maxlength="51" />

              <mat-error *ngIf="mainForm.get('title')?.hasError('minlength')">
                Title must be at least 2 characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('required')">
                Title is required
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('maxlength')">
                Title cannot exceed 50 characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('onlyNumbers')">
                Title cannot contain only numbers
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('onlySpecialChars')">
                Title cannot contain only special characters
              </mat-error>

              <mat-error *ngIf="mainForm.get('title')?.hasError('noAlphabet')">
                Title must contain at least one alphabet character
              </mat-error>
            </mat-form-field>
          </label>
        </div>

        <!-- Show different buttons based on edit mode -->
        <div class="btn-wrapper-div"
          *ngIf="coloringImageTranslations?.length !== languages.length || isEditingTranslation">
          <p *ngIf="!isEditingTranslation">Add at least one translation to save</p>

          <!-- Add Button - Show only when NOT editing -->
          <button *ngIf="!isEditingTranslation" type="button" (click)="addColoringImageTable()"
            class="add-button unblock-pointer">
            Add
          </button>

          <!-- Edit Buttons - Show only when editing -->
          <div *ngIf="isEditingTranslation" class="edit-buttons">
            <button type="button" (click)="addColoringImageTable()" class="add-button unblock-pointer">
              <span>Add</span>
            </button>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="coloringImageTranslations?.length" class="tableWrapper purple-table">
      <table class="styled-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Language</th>
            <th>Title</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let coloringImg of coloringImageTranslations; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ getLanguageName(coloringImg.langId) }}</td>
            <td class="content-row">{{ coloringImg.title }}</td>
            <td>
              <div class="actionWrapper">
                <div *ngIf="coloringImg.langId !== 1" class="actionItem"
                  (click)="removeColoringImageTranslation(i, coloringImg.id)">
                  <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" />
                </div>
                <div class="actionItem" (click)="editColoringImageTranslation(i, coloringImg.id)">
                  <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="grid-wrapper tags-image-section">
      <label>
        <span>Tags</span>
        <div class="tags-collection">
          <div class="tags-item" *ngFor="let tag of TAGS" [ngClass]="{
              'tags-choosed': isTagSelected(tag),
              'tags-item': !isTagSelected(tag)
            }" (click)="toggleTag(tag)" style="cursor: pointer">
            <h6>{{ tag.name }}</h6>
          </div>
        </div>
      </label>
    </div>

    <div class="btnWrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button [disabled]="!coloringImageTranslations.length || isSubmitting" class="cmn-next-btn"
        (click)="createColoringImage()">
        {{ coloringImageId ? "Update" : "Save" }}
      </button>
    </div>
  </div>

  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader [visible]="imageUploading || loading" [message]="
    imageUploading ? 'Uploading file, please wait...' : 'Saving, Please wait'
  ">
</app-fullscreen-loader>
